import { IBasicUser } from '@sdk/contracts';

export const getUserFullName = (user: IBasicUser): string => {
  const fullName = [user.name, user.lastName];

  if (user.secondLastName) {
    fullName.push(user.secondLastName);
  }

  return fullName.join(' ');
};
